import React, {useEffect, useMemo} from "react";
import useAccessLevels from "../../../../hooks/use-access-levels";
import ProductInformation from "./product-information";
import DraggablePopover from "../index";


/**
 * @type {React.FC<React.PropsWithChildren<{
 *     partNo?: string,
 *     wrapperProps?: Partial<import('@mui/material').BoxProps>,
 *     buttonProps?: Partial<import('@mui/material').ButtonProps>,
 *     iconProps?: Partial<import('@mui/material').SvgIconProps>,
 * }>>}
 */
const ProductInformationPopover = ({
                                       partNo,
                                       children,
                                       wrapperProps,
                                       buttonProps,
                                       iconProps,
                                       startingTab,
                                       cancelSelector,
                                   }) => {
    const operatorAccessLevels = useAccessLevels();

    const canRenderPopover = useMemo(() => operatorAccessLevels.packages.lookup.lookupProductInformation && !!partNo, [partNo, operatorAccessLevels.packages.lookup.lookupProductInformation]);

    /**
     * Shows the warning if the partNo and partId are not provided
     */
    useEffect(() => {
        if (!partNo) {
            console.warn('ProductInformationPopover requires partNo to be provided');
        }
    }, [partNo]);

    return (
        <>
            <DraggablePopover
                popupId={`part-info-of-${encodeURIComponent(partNo)}`}
                canRenderPopover={canRenderPopover}
                wrapperProps={wrapperProps}
                buttonProps={{
                    ...buttonProps,
                    sx: (...args) => ({
                        textAlign: 'start',
                        alignItems: 'flex-start !important',
                        ...(typeof buttonProps?.sx === "function" ? buttonProps.sx(...args) : buttonProps?.sx),
                    }),
                }}
                iconProps={iconProps}
                popoverElement={<ProductInformation partNo={partNo} startingTab={startingTab}/>}
                draggableProps={{
                    cancel: `.draggable-popover-cancel , .product-on-purchase-popover-class , .warehouse-schedule-management-dialog ${cancelSelector ? `, ${cancelSelector}` : ""}`,
                }}
                popperProps={{
                    slotProps: {
                        root: {
                            className: "product-information-popover-class",
                        },
                    },
                }}
            >
                {children}
            </DraggablePopover>
        </>
    );
}

export default ProductInformationPopover;